/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramCategoryControllerFindOneByLinkQueryResponse,
  TelegramCategoryControllerFindOneByLinkPathParams,
  TelegramCategoryControllerFindOneByLink401,
  TelegramCategoryControllerFindOneByLink404,
} from '../../types/TelegramCategoryControllerFindOneByLink.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramCategoryFindOneByLink } from '../../methods/telegramCategoryFindOneByLink.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramCategoryFindOneByLinkQueryKey = (
  link: TelegramCategoryControllerFindOneByLinkPathParams['link'],
) => [{ url: '/api/telegram/category/link/:link', params: { link: link } }] as const;

export type TelegramCategoryFindOneByLinkQueryKey = ReturnType<typeof telegramCategoryFindOneByLinkQueryKey>;

export function telegramCategoryFindOneByLinkQueryOptions(
  link: TelegramCategoryControllerFindOneByLinkPathParams['link'],
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramCategoryFindOneByLinkQueryKey(link);
  return queryOptions<
    TelegramCategoryControllerFindOneByLinkQueryResponse,
    ResponseErrorConfig<TelegramCategoryControllerFindOneByLink401 | TelegramCategoryControllerFindOneByLink404>,
    TelegramCategoryControllerFindOneByLinkQueryResponse,
    typeof queryKey
  >({
    enabled: !!link,
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramCategoryFindOneByLink(link, config);
    },
  });
}

/**
 * {@link /api/telegram/category/link/:link}
 */
export function useTelegramCategoryFindOneByLink<
  TData = TelegramCategoryControllerFindOneByLinkQueryResponse,
  TQueryData = TelegramCategoryControllerFindOneByLinkQueryResponse,
  TQueryKey extends QueryKey = TelegramCategoryFindOneByLinkQueryKey,
>(
  link: TelegramCategoryControllerFindOneByLinkPathParams['link'],
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramCategoryControllerFindOneByLinkQueryResponse,
        ResponseErrorConfig<TelegramCategoryControllerFindOneByLink401 | TelegramCategoryControllerFindOneByLink404>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramCategoryFindOneByLinkQueryKey(link);

  const query = useQuery(
    {
      ...telegramCategoryFindOneByLinkQueryOptions(link, config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<TelegramCategoryControllerFindOneByLink401 | TelegramCategoryControllerFindOneByLink404>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
